<template>
  <GlobalSearchComponent
    :large="true"
    v-chakra
    :mt="{ base: '21px', md: '80px' }"
    :mx="{ base: '-23px', md: 0 }"
  ></GlobalSearchComponent>
</template>

<script lang="ts">
import GlobalSearchComponent from "@/components/globalSearch/GlobalSearchComponent.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    GlobalSearchComponent,
  },
  mounted() {
    window.scrollTo(0, 0);
    this.$store.dispatch("globalSearch/reSearchIfSmallResults");
  },
});
</script>

<style lang="scss">
@import "../design-system/assets/tokens/tokens";
.wrapperz {
  background-color: white !important;
  @media (min-width-for("md")) {
    background-color: $color-iloq-gray-lightest !important;
  }
}
</style>
